import PropTypes from 'prop-types';

import { Abstrap } from '../..';

const propTypes = { ...Abstrap.propTypes, state: PropTypes.oneOf(['pending', 'info', 'success', 'error']).isRequired };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    state: 'pending',
};

class NotificationItem extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            state,
        } = this.props;
        return [
            'c-notification__item',
            state === 'pending' ? 'c-notification__item_state_loading' : false,
            state === 'info' ? 'c-notification__item_state_info' : false,
            state === 'success' ? 'c-notification__item_state_success' : false,
            state === 'error' ? 'c-notification__item_state_error' : false,
            className,
        ];
    }

}

NotificationItem.propTypes = propTypes;

NotificationItem.defaultProps = defaultProps;

export default NotificationItem;
